/* tslint:disable */
/* eslint-disable */

/**
 * Last status of the task
 */
export enum TaskStatus {
  None = 'none',
  Requested = 'requested',
  Completed = 'completed',
  Error = 'error'
}
